var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTelega = function SvgTelega(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.48 5.399 4.63 9.197c-.672.27-.668.645-.123.812l2.53.79 5.85-3.692c.277-.169.53-.078.322.106l-4.74 4.279h-.002.001L8.294 14.1c.255 0 .368-.117.512-.256l1.228-1.194 2.555 1.887c.471.26.81.126.927-.436l1.677-7.905c.171-.688-.263-1-.712-.796Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.333,
    cy: 10,
    r: 9,
    stroke: "currentColor",
    strokeWidth: 2
  })));
};
export default SvgTelega;